import Wrapper from "../../../layout/Wrapper";
import UserManageComponent from "../../../screens/settings/users/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "User Management",
	description: "",
};

export default function UserManagement() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<UserManageComponent />
		</Wrapper>
	);
}